import { useRequest } from 'ahooks';
import { useEffect, useState } from 'react';
import {
  addPortalService,
  deletePortalService,
  editPortalService,
  queryPortalsService,
} from './services';
import { IDirMenusProps, IPortalProps } from './typing';

export default function PortalMgrModel() {
  const [selectedPortal, setSelectedPortal] = useState<IPortalProps | null>(
    null,
  );
  const [selectedMenu, setSelectedMenu] = useState<IDirMenusProps | null>(null);

  const {
    data: portalList,
    run,
    refresh,
  } = useRequest(queryPortalsService, {
    manual: true,
  });

  const addPortal = async (data: IPortalProps) => {
    await addPortalService(data);
    refresh();
  };

  const editPortal = async (data: IPortalProps) => {
    await editPortalService(data);
    refresh();
  };

  const deletePortal = async (portalId: number) => {
    await deletePortalService(portalId);
    refresh();
  };

  useEffect(() => {
    if (portalList?.length) {
      setSelectedPortal(portalList[0]);
    } else {
      setSelectedPortal(null);
    }
  }, [portalList]);

  return {
    portalList,
    queryPortalList: run,
    addPortal,
    editPortal,
    deletePortal,
    selectedMenu,
    setSelectedMenu,
    selectedPortal,
    setSelectedPortal,
  };
}
